import { createTheme } from "@mui/material";
import { themeOptions } from "./ThemeConfig";

export const appTheme = createTheme(themeOptions);
